export default __webpack_public_path__ + "static/media/41.8bb7ea4a.jpeg";